<overlay-scrollbars [defer]="true">
  <div class="tree-container">
    <svg #treeSvg></svg>
  </div>
</overlay-scrollbars>
